import classNames from 'classnames';
import React from 'react';

import {LegacyMeasurement as MeasurementType} from 'constants/MeasurementConstants';

import * as TransferUtil from './TransferUtil';

interface MeasurementProps {
  measurement?: MeasurementType;
}

export function Measurement({measurement}: MeasurementProps): JSX.Element {
  return (
    <span className={classNames({'u-faded': measurement?.value == null})}>
      {TransferUtil.getLegacyMeasurementString(measurement)}
    </span>
  );
}

interface MeasurementValueProps {
  value: number | null;
}

export function MeasurementValue({value}: MeasurementValueProps): JSX.Element {
  if (value == null) {
    return <span className="u-faded">Not specified</span>;
  }
  return <span>{TransferUtil.getMeasurementValueString(value)}</span>;
}
